import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../styles/pages/Aboutus.module.scss"
import Link from 'next/link'
import Topbanner from '../components/Topbanner/Topbanner'
import Slider from "react-slick";
import Instagallery from '../components/InstaGallery/Instagallery'
import AboutGallery from '../components/AboutGallery/AboutGallery';

export default function AboutUs() {

    const gallery_slider = {
        dots: true,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const amenities = [{
        title: "Restaurant & Bar",
        description: "Experience the best hospitality at our Restaurant and Bar! Located in the heart of the Kufri, our restaurant and bar offers top-notch services with unbeatable rates.",
        hyperLink: "/",
        icon: "/icons/spoon.svg"
    },
    {
        title: "Conference Hall",
        description: "Need a place for your next conference or meeting? Look no further! Our conference hall at the hotel offers the perfect space for any event. Enjoy flexible seating arrangements, modern amenities.",
        hyperLink: "/",
        icon: "/icons/frame.svg"
    },
    {
        title: "Parking",
        description: "Experience the convenience of secure hotel parking at The Twin Towers Hotel. You can rest assured knowing that your car is safe and secure, no matter how long your stay.",
        hyperLink: "/",
        icon: "/icons/parking.svg"
    },
    {
        title: "WiFi",
        description: "We provide free wifi with a high-speed connection, so you can work on the go with all the amenities of home. Enjoy secure, reliable internet access with no hidden fees or extra charges.",
        hyperLink: "/",
        icon: "/icons/wifi.svg"
    },
    {
        title: "Adventure Activities",
        description: "Looking for an adventure activity? Come to Adventure Resorts Kufri to experience a unique and thrilling adventure! We offer variety of activities and promise you a memorable experience",
        hyperLink: "/",
        icon: "/icons/adventure.svg"
    },
    {
        title: "Banquet Hall",
        description: "Our banquet hall is equipped with state-of-the-art technologies, including cutting-edge lighting and audio-visual equipment that can be customized to match your dream event.",
        hyperLink: "/",
        icon: "/icons/banquet.svg"
    },
    {
        title: "Valley View",
        description: "Experience the beauty of the Himalayas from the comfort of our luxurious hotel. Enjoy breathtaking views of valleys and mountains while enjoying our top-notch amenities and services.",
        hyperLink: "/",
        icon: "/icons/valley.svg"
    },
    {
        title: "Cozy Rooms",
        description: "Enjoy an unforgettable stay in one of our cozy rooms! Our hotel offers comfortable and affordable accommodations for your next vacation or business trip.",
        hyperLink: "/",
        icon: "/icons/cozy.svg"
    },
    ];
    
    const galleryImages = [
        {
            bgImage: "/images/about-gal1.png",
            altTest: "bar image",
        },
        {
            bgImage: "/images/about-gal2.png",
            altTest: "wedding image",
        },
        {
            bgImage: "/images/about-gal3.png",
            altTest: "hotel image",

        },
        {
            bgImage: "/images/about-gal5.png",
            altTest: "banquet image",
        },
        {
            bgImage: "/images/about-gal6.png",
            altTest: "mocktail image",

        },
    ];

    return (
        <>
            <Head>
                <title>About us | Stay in Best Hotel In Kufri |  The Twin Towers Hotel in Shimla</title>
                <meta name="description" content="Book your stay at The Twin Towers Hotel in Shimla, best hotel Room in Shimla the excellent accommodation in Himachal Pradesh. We offer Family and Couple Bugest Friendly Hotel Rooms In Kufri." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/about-us" />
                <meta name="keywords" content="Shimla Hotel Booking shimla hotel room booking Hotel Rooms In Shimla best tourist places to visit in shimla hotel room images room luxury hotel room types shimla room rent"></meta>
            </Head>
            <Topbanner bgImage={"/images/about-banner.png"} title={"About Us"} />
            <section className={`${styles.aboutus} `}>
                <div className={`${styles.about_top} common_padding pb-0`}>
                    <div className='container'>
                        <div className='common_title text-center'>
                            <h4>Who we are</h4>
                            <h2>The Twin Towers Hotel - Since 2014</h2>
                            <p><strong>Welcome to The Twin Towers (New Kufri)</strong> designed to give you a warm & luxurious experience. We, at The Twin Towers, Kufri are nestled with an exotic ambience, and provide you with a youthful experience and a touch of sophistication. Blessed with the panoramic view of the lofty Himalayas and lush greenery spread all over, here, the soothing breeze blends perfectly with the joyful mood, giving you a remarkable experience worth cherishing for a lifetime. Undoubtedly, the Twin Towers is a feast for your soul – to calm your senses down with its refreshing atmosphere and exquisite Himalayan surroundings.</p>
                        </div>
                    </div>
                    <div className={styles.about_img_sec}>
                        <Image src="/images/Gallery/about-img.jpg" layout="fill" objectFit="cover" alt='About twin-tower hotel Image'></Image>
                    </div>
                    <div className='container'>
                        <div className='common_title text-center py-4'>
                            <p>The Twin Towers, Kufri comes replete with a complete sense of hospitality, incomparable amenities and wide range of cuisines to take care of you while you’re here. The location of the Twin Towers, Kufri, is a heaven in itself – we are set in a picturesque setting underneath the pine trees, well-designed rooms with detailing and plush interiors, elevator and wooden flooring, keeping in mind the luxury you deserve.</p>
                        </div>
                    </div>
                </div>

                <div className={`${styles.about_bottom} common_padding pb-0`}>
                    <div className='container'>
                        <div className='common_title'>
                            <h2 className='text-center'>Highlights</h2>
                            <div className={`${styles.amenities_main} row`}>
                                {amenities.map((item, index) => (
                                    <div key={index} className="col-lg-3 col-md-6">
                                        <div className={styles.amenities}>
                                            <Image src={item.icon} width={38} height={38} className={styles} alt="Highlights icon" />
                                            <h3>{item.title}</h3>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <AboutGallery galleryImages={galleryImages} galleryHeading={'Our Gallery'} />
                {/* <div className={styles.our_gallery}>
                    <div className='container'>
                        <div className='common_title'>
                            <h2 className='text-center'>Our Gallery</h2>
                        </div>
                        <div className={styles.gallery_main}>
                            <Slider {...gallery_slider} className="gallery_slider">
                                {gallery.map((item, index) => (
                                    <div className={styles.gallery_child} key={index}>
                                        <img src={item.bgImage} alt={item.altTest}/>
                                    </div>
                                ))}
                            </Slider>
                        </div>

                    </div>
                </div> */}

            </section>
            <Instagallery />
        </>
    )
}
